import Cookies from "js-cookie";
import constants from "../values/constants";

interface iProps {
  token: string;
  avatar: string;
  userId: string;
  balance: any;
  fullName: string;
  userType: string;
}

const USER = constants.USER;

export function set(props: iProps) {
  Cookies.set(USER.TYPE, props.userType, { expires: 7 });
  Cookies.set(USER.TOKEN, props.token, { expires: 7 });
  Cookies.set(USER.AVATAR, props.avatar, { expires: 7 });
  Cookies.set(USER.BALANCE, props.balance, { expires: 7 });
  Cookies.set(USER.IDENTIFY, props.userId, { expires: 7 });
  Cookies.set(USER.FULL_NAME, props.fullName, { expires: 7 });
  return true;
}

export function remove() {
  Cookies.remove(USER.TYPE);
  Cookies.remove(USER.TOKEN);
  Cookies.remove(USER.AVATAR);
  Cookies.remove(USER.BALANCE);
  Cookies.remove(USER.IDENTIFY);
  Cookies.remove(USER.FULL_NAME);
  window.location.href = "/panel/login";
  return true;
}
